export type SentryEnvironment = 'production' | 'staging' | 'development' | 'unknown';

const PRODUCTION_TARGETS = new Set(['medd-production', 'boston-production']);
const STAGING_TARGETS = new Set(['medd-staging', 'boston-staging']);

export function resolveSentryApp(deployTarget: string): 'medd-sim' | 'medd-sim-bsc' {
  return deployTarget.startsWith('boston-') ? 'medd-sim-bsc' : 'medd-sim';
}

export function resolveSentryEnvironment(
  deployTarget: string,
  hostname: string,
): SentryEnvironment {
  if (PRODUCTION_TARGETS.has(deployTarget)) return 'production';
  if (STAGING_TARGETS.has(deployTarget)) return 'staging';

  const normalisedHost = hostname.trim().toLowerCase();
  if (!normalisedHost) return 'unknown';
  if (
    normalisedHost === 'localhost'
    || normalisedHost === '127.0.0.1'
    || normalisedHost.endsWith('.local')
  ) return 'development';
  if (normalisedHost.startsWith('staging-') || normalisedHost.endsWith('.vercel.app')) {
    return 'staging';
  }
  if (normalisedHost === 'medd.com.au' || normalisedHost.endsWith('.medd.com.au')) {
    return 'production';
  }
  return 'development';
}
